module.exports = __webpack_public_path__ + "static/media/mumbaiflood.2db206df.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/mumbaiflood.gif
// module id = 344
// module chunks = 0